window.ajaxFormRequest = function(param) {
  let msg;

  if (typeof param.target == "undefined") param.target = "#ajax-modal";
  if (typeof param.data == "undefined") param.data = {};

  let $target = $(param.target);

  $.ajax({
    url: param.url,
    type: "GET",
    dataType: "json", //expect json as return
    data: param.data,
    beforeSend: function(jqXHR, settings) {
      msg = Messenger().post({
        message: "Processing...",
        type: "info",
        hideAfter: 20,
        showCloseButton: true,
        hideOnNavigate: true,
        singleton: true
      });
    },
    error: function(e) {
      let message = "";

      console.error(e);
      if (e.hasOwnProperty("responseJSON")) {
        message = sprintf(
          "%s %s",
          e.responseJSON.hasOwnProperty("exception")
            ? e.responseJSON.exception + "."
            : "",
          e.responseJSON.message
        );
      } else if (e.hasOwnProperty("responseText")) {
        message = e.responseText;
      }

      msg.update({
        message: sprintf(
          'Error encountered. <div class="mt-20">%s</div>',
          message
        ),
        type: "error"
      });

      $target.modal("hide");

      setTimeout(function() {
        msg.hide();
      }, 5000);
    },
    success: function(result) {
      if (result.hasOwnProperty("html")) {
        $target.find(".modal-body").html(result.html);

        setTimeout(function() {
          $target.find("form :input:enabled:visible:first").focus();
        }, 400);
      }

      if (param.hasOwnProperty("relatedTarget"))
        result["relatedTarget"] = param.relatedTarget;

      if (
        typeof param.successShown != "undefined" &&
        typeof param.successShown === "function"
      )
        param.successShown(result, $target);

      if (result.success != null && !result.success) {
        msg.update({ message: result.message, type: "error" });
      } else {
        if (result.message != null && result.message.length > 0) {
          msg.update({ message: result.message, type: "success" });
        } else {
          msg.update({ message: "Done!", type: "success" });
        }
      }

      $target.trigger("fetched.modal", [result, $target]);

      setTimeout(function() {
        msg.hide();
      }, 500);
    }
  });
};
/*
window.ajaxRequest = function (param) {
  let msg;

  if (!param.hasOwnProperty("type")) param.type = "GET";
  if (!param.hasOwnProperty("notification")) param.notification = {successDelay: 500, errorDelay: 2000};
  if (!param.hasOwnProperty("data")) param.data = null;

  $.ajax({
    url: param.url,
    type: param.type,
    dataType: "json",//expect json as return
    data: param.data,
    beforeSend: function (jqXHR, settings) {
      if (param.hasOwnProperty("anchor")) {
        param.anchor.data('original-text', param.anchor.html());
        param.anchor.html('<i class="spinners"></i>');
      }

      msg = Messenger().post({
        message: 'Processing...',
        type: 'info',
        hideAfter: 20,
        showCloseButton: true,
        hideOnNavigate: true
      });

      if (param.beforeSend && typeof(param.beforeSend) === "function") param.beforeSend(jqXHR, settings);
    },
    error: function (e) {
      if (param.hasOwnProperty("anchor")) param.anchor.html(param.anchor.data('original-text'));

      msg.update({
        message: sprintf('Error encountered. <div class="mt-20">%s %s</div>', (e.responseJSON.hasOwnProperty('exception')) ? e.responseJSON.exception + '.' : '', e.responseJSON.message),
        type: 'error'
      });

      if (param.error && typeof(param.error) === "function") param.error(e);

      setTimeout(function () {
        msg.hide();
      }, 5000);
    },
    success: function (result) {
      if (param.hasOwnProperty("anchor")) param.anchor.html(param.anchor.data('original-text'));

      // if(result.hasOwnProperty('html')) $('.bootbox .modal-body').html(result.html);
      if (typeof(param.successShown) != 'undefined' && typeof(param.successShown) === "function") param.successShown(result);

      if (result.success != null && !result.success) {
        msg.update({message: result.message, type: 'error'});
      } else {
        if (result.message != null && result.message.length > 0) {
          msg.update({message: result.message, type: 'success'});
        } else {
          msg.update({message: 'Done!', type: 'success'});
        }

        if (result.success && (param.success && typeof(param.success) === "function")) param.success(result);
      }

      setTimeout(function () {
        msg.hide();
      }, (result.success) ? param.notification.successDelay : param.notification.errorDelay);
    }
  });
};
*/

window.ajaxFormModal = parameters => {
  // param = typeof param != 'undefined' ? param : {autoClose: false};
  //
  // if (typeof param.container == 'undefined') param.container = '#ajax-modal';

  let param = {
    autoClose: false,
    container: "#ajax-modal",
    fetched: null,
    successShown: null,
    ...parameters
  };

  let container = param.container;

  let options = {
    dataType: "json",
    //target:        '#ajax-form-container',
    container: container,
    // delegation: true,
    beforeSerialize: function($form, options) {
      if (
        typeof param.beforeSerialize != "undefined" &&
        typeof param.beforeSerialize === "function"
      )
        param.beforeSerialize($form, options, $(param.container));
    },
    beforeSubmit: function(arr, $form, options) {
      $(param.container + " .modal-body").html(
        '<i class="spinners"></i> Loading..'
      );

      if (
        typeof param.beforeSubmit != "undefined" &&
        typeof param.beforeSubmit === "function"
      )
        param.beforeSubmit(arr, $form, options, $(param.container));
    },
    error: function(e) {
      // $(param.container + ' .modal-body').html(sprintf('Error encountered. <div class="mt-3">%s %s</div>', (e.responseJSON.hasOwnProperty('exception')) ? e.responseJSON.exception + '.' : '', e.responseJSON.message));
      $(param.container + " .modal-body").html(
        sprintf(
          '<span class="text-danger">Error encountered</span> <div class="mt-1">%s</div>',
          e.responseJSON.message
        )
      );
    },
    success: function(result, status) {
      $(param.container + " .modal-body").html(result.html);

      $(param.container)
        .find("form :input:enabled:visible:first")
        .focus();

      if (
        typeof param.successShown != "undefined" &&
        typeof param.successShown === "function"
      )
        param.successShown(result, $(param.container));
      else $(param.container).trigger("shown.bs.modal");

      if (param.hasOwnProperty("relatedTarget"))
        result["relatedTarget"] = param.relatedTarget;

      // if (result.fetched && (param.fetched && typeof param.fetched === 'function'))
      //   param.fetched(result, $(param.container));
      $(param.container).trigger("fetched.modal", [result, $(param.container)]);

      // flag to handle callback action after ajax request in dialog form
      window.form_success = result.success ? true : false;

      if (result.success && param.autoClose !== false) {
        setTimeout(function() {
          $(param.container).modal("hide");
        }, param.autoClose);
      }

      if (!result.hasOwnProperty("model")) result["model"] = null;

      // $(param.container).trigger('fetched.modal', [result, $(param.container)]);

      if (
        result.success &&
        (param.success && typeof param.success === "function")
      )
        param.success(result, $(param.container));
    }

    // other available options:
    //url:       url         // override for form's 'action' attribute
    //type:      type        // 'get' or 'post', override for form's 'method' attribute
    //dataType:  null        // 'xml', 'script', or 'json' (expected server response type)
    //clearForm: true        // clear all form fields after successful submit
    //resetForm: true        // reset the form after successful submit

    // $.ajax options can be used here too, for example:
    //timeout:   3000
  };

  // bind form using 'ajaxForm'
  let target = param.container + " form";

  $.initialize(target, function() {
    $(this).ajaxForm(options);
  });

  $(param.container).on("show.bs.modal", function(e) {
    if (!param.data) param.data = {};

    if (typeof e.relatedTarget !== "undefined") {
      param.relatedTarget = e.relatedTarget;

      if ($(param.relatedTarget).attr("data-selected-ids")) {
        param.data["ids"] = $(param.relatedTarget).attr("data-selected-ids");
      }

      // $(param.relatedTarget).attr('data-bulk-*')

      if ($(param.relatedTarget).data("target-title")) {
        $(param.container)
          .find(".modal-title")
          .text($(param.relatedTarget).data("target-title"));
      }
    }

    // initiate modal ajax request to display form
    ajaxFormRequest({
      url: $(param.relatedTarget).data("modal-href"),
      target: $(param.relatedTarget).data("target"),
      data: param.data,
      fetch: param.fetched,
      successShown: param.successShown,
      relatedTarget: param.relatedTarget
    });

    if (typeof param.show != "undefined" && typeof param.show === "function") {
      param.show(e, $(param.container));
    }
  });

  if (
    typeof param.fetched != "undefined" &&
    typeof param.fetched === "function"
  ) {
    $(param.container).on("fetched.modal", function(e, response, $target) {
      // delay trigger callback to wait all have been inited on slower machine
      // setTimeout(function () {
      param.fetched(response, $target);
      // }, 200);
    });
  }

  if (typeof param.shown != "undefined" && typeof param.shown === "function") {
    $(param.container).on("shown.bs.modal", function(e) {
      // delay trigger callback to wait all have been inited on slower machine
      setTimeout(function() {
        param.shown(e, $(param.container));
      }, 200);
    });
  }

  $(param.container).on("hidden.bs.modal", function(e) {
    $(this).removeData("bs.modal");
    $(this)
      .find(".modal-body")
      .html('<i class="spinners"></i> Loading...');

    if (
      typeof param.hidden != "undefined" &&
      typeof param.hidden === "function"
    ) {
      param.hidden(e, $(param.container));
    }
  });

  // (function (options2) {
  //   $(target).ajaxForm(options2);
  // })(options);
};

/*
window.ajaxPagination = function (param) {
  const target = param.target;
  const linkSelector = param.links;

  $('#container').on('click', linkSelector, function(e) {
    ajaxRequest({
      url: $(this).attr('href'),
      dataType: 'json',
      notification: {
        successDelay: 1000,
        errorDelay: 5000
      },
      beforeSend: function(){
        $(target).fadeTo(100, 0.5);
      },
      success: function(response) {
        $(target).html(response.html).fadeTo(100, 1);
      }
    });

    return false;
  });
}

window.copyUrlToClipboard = function (target) {
  $inputGroup = $(target).closest('.input-group');

  const el = document.createElement('textarea');
  // el.value = `${$inputGroup.find('.input-group-prepend > .input-group-text').text()}${$inputGroup.find('input#seo_url').val()}`;
  el.value = `${$inputGroup.find('input.copyable').val()}`;
  el.setAttribute('readonly', '');
  el.style.position = 'absolute';
  el.style.left = '-9999px';
  document.body.appendChild(el);

  const selected =
    document.getSelection().rangeCount > 0
      ? document.getSelection().getRangeAt(0)
      : false;
  el.select();
  document.execCommand('copy');
  document.body.removeChild(el);

  if (selected) {
    document.getSelection().removeAllRanges();
    document.getSelection().addRange(selected);
  }

  msg = Messenger().post({
    message: 'Copied',
    type: 'success',
    hideAfter: 1,
    showCloseButton: true,
    hideOnNavigate: true,
    singleton: true
  });
}*/

window.ajaxRequest = function(param) {
  let msg;

  if (!param.hasOwnProperty("type")) param.type = "GET";
  if (!param.hasOwnProperty("notification"))
    param.notification = { successDelay: 500, errorDelay: 2000 };
  if (!param.hasOwnProperty("data")) param.data = null;

  $.ajax({
    url: param.url,
    type: param.type,
    dataType: "json", //expect json as return
    data: param.data,
    beforeSend: function(jqXHR, settings) {
      if (param.hasOwnProperty("anchor")) {
        param.anchor.data("original-text", param.anchor.html());
        param.anchor.html('<i class="spinners"></i>');
      }

      msg = Messenger().post({
        message: "Processing...",
        type: "info",
        hideAfter: 20,
        showCloseButton: true,
        hideOnNavigate: true
      });

      if (param.beforeSend && typeof param.beforeSend === "function")
        param.beforeSend(jqXHR, settings);
    },
    error: function(e) {
      if (param.hasOwnProperty("anchor"))
        param.anchor.html(param.anchor.data("original-text"));

      msg.update({
        message: sprintf(
          'Error encountered. <div class="mt-20">%s %s</div>',
          e.responseJSON.hasOwnProperty("exception")
            ? e.responseJSON.exception + "."
            : "",
          e.responseJSON.message
        ),
        type: "error"
      });

      if (param.error && typeof param.error === "function") param.error(e);

      setTimeout(function() {
        msg.hide();
      }, 5000);
    },
    success: function(result) {
      if (param.hasOwnProperty("anchor"))
        param.anchor.html(param.anchor.data("original-text"));

      // if(result.hasOwnProperty('html')) $('.bootbox .modal-body').html(result.html);
      if (
        typeof param.successShown != "undefined" &&
        typeof param.successShown === "function"
      )
        param.successShown(result);

      if (result.success != null && !result.success) {
        msg.update({ message: result.message, type: "error" });
      } else {
        if (result.message != null && result.message.length > 0) {
          msg.update({ message: result.message, type: "success" });
        } else {
          msg.update({ message: "Done!", type: "success" });
        }

        if (
          result.success &&
          (param.success && typeof param.success === "function")
        )
          param.success(result);
      }

      setTimeout(
        function() {
          msg.hide();
        },
        result.success
          ? param.notification.successDelay
          : param.notification.errorDelay
      );
    }
  });
};

window.ajaxPost = function(param) {
  if (!param.hasOwnProperty("type")) param.type = "GET";
  if (!param.hasOwnProperty("data")) param.data = null;
  if (!param.hasOwnProperty("btnCancel"))
    param.btnCancel = { label: "Cancel", className: "btn-default" };
  if (!param.hasOwnProperty("notification"))
    param.notification = { successDelay: 500, errorDelay: 2000 };
  if (!param.hasOwnProperty("activeModal")) param.activeModal = false;

  if (!param.notification.hasOwnProperty("successDelay"))
    param.notification.successDelay = 1000;
  if (!param.notification.hasOwnProperty("errorDelay"))
    param.notification.errorDelay = 2000;

  let msg;

  bootbox.dialog({
    message: param.message,
    title: param.title,
    centerVertical: true,
    buttons: {
      cancel: {
        label: param.btnCancel.label,
        className: param.btnCancel.className
      },
      main: {
        label: param.btnMain.label,
        className: param.btnMain.className,
        callback: function() {
          $.ajax({
            url: param.url,
            type: param.type, //request is a POSt request
            dataType: "json", //expect json as return
            data: param.data,
            beforeSend: function(jqXHR, settings) {
              if (param.hasOwnProperty("anchor")) {
                param.anchor.data("original-text", param.anchor.html());
                param.anchor.html('<i class="spinners"></i> Loading ...');
              }

              if (param.activeModal)
                $(".bootbox .modal-body").html(
                  '<i class="spinners"></i> Loading ...'
                );

              msg = Messenger().post({
                message: '<i class="spinners"></i> Processing...',
                type: "info",
                hideAfter: 20,
                showCloseButton: true,
                hideOnNavigate: true,
                singleton: true
              });

              if (param.beforeSend && typeof param.beforeSend === "function")
                param.beforeSend(jqXHR, settings);
            },
            error: function(e) {
              if (param.hasOwnProperty("anchor"))
                param.anchor.html(param.anchor.data("original-text"));

              let message = "";

              if (e.hasOwnProperty("responseJSON")) {
                message = sprintf(
                  "%s %s",
                  e.responseJSON.hasOwnProperty("exception")
                    ? e.responseJSON.exception + "."
                    : "",
                  e.responseJSON.message
                );
              } else if (e.hasOwnProperty("responseText")) {
                message = e.responseText;
              }

              msg.update({
                message: sprintf(
                  'Error encountered. <div class="mt-20">%s</div>',
                  message
                ),
                type: "error"
              });

              if (param.error && typeof param.error === "function")
                param.error(e);

              setTimeout(function() {
                msg.hide();
              }, 5000);
            },
            success: function(result) {
              if (param.hasOwnProperty("anchor"))
                param.anchor.html(param.anchor.data("original-text"));

              if (result.hasOwnProperty("html"))
                $(".bootbox .modal-body").html(result.html);

              if (
                typeof param.successShown != "undefined" &&
                typeof param.successShown === "function"
              )
                param.successShown(result);

              if (result.success != null && !result.success) {
                msg.update({ message: result.message, type: "error" });
              } else {
                if (result.message != null && result.message.length > 0) {
                  msg.update({ message: result.message, type: "success" });
                } else {
                  msg.update({ message: "Done!", type: "success" });
                }

                if (
                  result.success &&
                  (param.success && typeof param.success === "function")
                )
                  param.success(result);
              }

              setTimeout(
                function() {
                  msg.hide();

                  if (param.activeModal) bootbox.hideAll();
                },
                result.success
                  ? param.notification.successDelay
                  : param.notification.errorDelay
              );
            }
          });

          if (param.activeModal) return false;
        }
      }
    }
  });
};

window.ajaxTableEditable = function(param) {
  $.initialize(param.element + " input", function() {
    $(this).bind("keypress", function(e) {
      if (e.keyCode == 13 || e.keyCode == 40) {
        // Enter pressed... do anything here...
        $(this)
          .parents("tr")
          .next()
          .find("td.editable")
          .trigger("click");
      } else if (e.keyCode == 38) {
        $(this)
          .parents("tr")
          .prev()
          .find("td.editable")
          .trigger("click");
      }
    });
  });

  $.initialize(param.element, function() {
    $(this).editable(
      function(value, settings) {
        let editable = $(this);
        let totalPrice = param.hasOwnProperty("siblingTotalPrice")
          ? $(this).siblings(param.siblingTotalPrice)
          : null;
        let totalProfit = param.hasOwnProperty("siblingTotalProfit")
          ? $(this).siblings(param.siblingTotalProfit)
          : null;
        let profitClass = "";

        let originalPrice = $(this).attr("abbr");

        if (parseFloat(originalPrice) - parseFloat(value) != 0) {
          ajaxRequest({
            url: $(this).data("href"),
            data: { price: value },
            success: function(response) {
              if (!response.success) {
                bootbox.dialog({
                  message: response.html,
                  title: "Error",
                  buttons: {
                    cancel: { label: "Cancel", className: "btn btn-default" },
                    main: {
                      label: "OK",
                      className: "btn btn-primary",
                      callback: function() {}
                    }
                  }
                });
              } else {
                if (totalPrice)
                  totalPrice.text(response.total_price).show("highlight");

                if (totalProfit && response.hasOwnProperty("total_profit")) {
                  if (response.total_profit > 0) {
                    response.total_profit = "+" + response.total_profit;
                    profitClass = "positive";
                  } else if (response.total_profit == 0) {
                    profitClass = "neutral";
                  } else {
                    profitClass = "negative";
                  }

                  if (totalProfit != "undefined")
                    totalProfit
                      .find("span:first")
                      .removeClass()
                      .addClass(profitClass)
                      .text(response.total_profit)
                      .show("highlight");
                }

                editable.attr("abbr", value);
              }
            }
          });
        }

        return value;
      },
      {
        onblur: "submit",
        select: true,
        indicator: "Saving...",
        tooltip: "Click to edit",
        data: (value, settings) => {
          return value.trim();
        },
        inputcssclass: "editable-input"
      }
    );
  });
};

window.pjaxPost = function(param) {
  if (!param.hasOwnProperty("type")) param.type = "GET";
  if (!param.hasOwnProperty("data")) param.data = null;
  if (!param.hasOwnProperty("container")) param.container = "#pjax-container";
  if (!param.hasOwnProperty("btnCancel"))
    param.btnCancel = { label: "Cancel", className: "btn-default" };
  if (!param.hasOwnProperty("activeModal")) param.activeModal = false;

  // let btnMain = param.btnMain || {};
  // param.btnMain = Object.assign(btnMain, param.btnMain);

  let msg;

  bootbox.dialog({
    message: param.message,
    title: param.title,
    buttons: {
      cancel: {
        label: param.btnCancel.label,
        className: param.btnCancel.className
      },
      main: {
        label: param.btnMain.label,
        className: param.btnMain.className,
        callback: function() {
          if (param.callback && typeof param.callback === "function")
            param.callback();

          $.pjax({
            url: param.url,
            container: param.container,
            push: true,
            scrollTo: true
          });

          if (param.activeModal) return false;
        }
      }
    }
  });
};

window.ajaxPostDeprecated = function(param) {
  if (!param.hasOwnProperty("btnCancel"))
    param.btnCancel = { label: "Cancel", className: "btn-default" };
  if (!param.hasOwnProperty("notification"))
    param.notification = { successDelay: 500, errorDelay: 2000 };

  if (!param.notification.hasOwnProperty("successDelay"))
    param.notification.successDelay = 500;
  if (!param.notification.hasOwnProperty("errorDelay"))
    param.notification.errorDelay = 2000;

  bootbox.dialog({
    message: param.message,
    title: param.title,
    buttons: {
      cancel: {
        label: param.btnCancel.label,
        className: param.btnCancel.className
      },
      main: {
        label: param.btnMain.label,
        className: param.btnMain.className,
        callback: function() {
          $.ajax({
            url: param.url,
            type: "GET", //request is a POSt request
            dataType: "json", //expect json as return
            beforeSend: function(jqXHR, settings) {
              if (param.hasOwnProperty("anchor")) {
                param.anchor.data("original-text", param.anchor.html());
                param.anchor.html('<i class="spinners"></i> Loading ...');
              }

              msg = Messenger().post({
                message: "Processing...",
                type: "info",
                hideAfter: 20,
                showCloseButton: true,
                hideOnNavigate: true,
                singleton: true
              });

              if (param.beforeSend && typeof param.beforeSend === "function")
                param.beforeSend(jqXHR, settings);
            },
            error: function(e) {
              if (param.hasOwnProperty("anchor"))
                param.anchor.html(param.anchor.data("original-text"));

              msg.update({
                message:
                  "Error encountered while processing the request. " +
                  e.responseText,
                type: "error"
              });

              if (param.error && typeof param.error === "function")
                param.error(e);

              setTimeout(function() {
                msg.hide();
              }, 5000);
            },
            success: function(result) {
              if (param.hasOwnProperty("anchor"))
                param.anchor.html(param.anchor.data("original-text"));

              if (result.success != null && !result.success) {
                msg.update({ message: result.message, type: "error" });
              } else {
                if (result.message != null && result.message.length > 0) {
                  msg.update({ message: result.message, type: "success" });
                } else {
                  msg.update({ message: "Done!", type: "success" });
                }

                if (
                  result.success &&
                  (param.success && typeof param.success === "function")
                )
                  param.success(result);
              }

              setTimeout(
                function() {
                  msg.hide();
                },
                result.success
                  ? param.notification.successDelay
                  : param.notification.errorDelay
              );
            }
          });
        }
      }
    }
  });
};

window.toggleFilter = function(element) {
  if (!$(element).is(":visible")) {
    $(element).show();
  } else {
    $(element).hide();
  }
};

window.toggleCheckBox = function(elements) {
  $(elements).each(function() {
    $(this).attr("disabled", !$(this).attr("disabled"));
  });
};

window.convertQuantityRemarks = function(value) {
  let result = new Object();

  if (value.length > 0 && value.indexOf("x") === -1) {
    let delimiter = "";
    let tokens = "";
    let total_boxes = 0;
    let total_weight = 0;

    if (value.indexOf("*") !== -1) {
      delimiter = value.indexOf("+") !== -1 ? "+" : ",";

      tokens = value.split(delimiter);

      let key = "";
      let segment = "";

      for (let i in tokens) {
        key = jQuery.trim(tokens[i]);

        if (key.length > 0) {
          segment = key.split("*");

          if (
            typeof segment[0] == "undefined" ||
            typeof segment[1] == "undefined" ||
            segment[0] == "" ||
            segment[1] == ""
          ) {
            alert("Incorrect syntax on " + key);

            return;
          }

          if (!(segment[1] in result)) result[segment[1]] = 0;

          result[segment[1]] += parseInt(segment[0]);
        }
      }
    } else {
      delimiter = value.indexOf("+") !== -1 ? "+" : ",";

      tokens = value.split(delimiter);

      for (let i in tokens) {
        let key = jQuery.trim(tokens[i]);

        if (key.length > 0) {
          if (!(key in result)) result[key] = 0;

          result[key] += 1;
        }
      }
    }

    sortable = [];

    for (let j in result) {
      sortable.push({ weight: parseFloat(j), count: result[j] });
      total_boxes += result[j];
      total_weight += j * result[j];
    }

    sortable.sort(function(a, b) {
      return a.weight > b.weight;
    });

    if (sortable.length > 0) {
      value = "";

      for (let i in sortable) {
        value += sortable[i].count + "x" + sortable[i].weight;

        if (i < sortable.length - 1) value += ", ";
      }
    }

    return {
      remarks: value,
      boxes: total_boxes,
      weight: total_weight,
      quantity: 1
    };
  }

  return false;
};

window.ajaxModalRequest = function(param) {
  let msg;

  let $target = $(param.target);

  if (param.hasOwnProperty('element') && param.element.data("target-title")) {
    $target.find(".modal-title").text(param.element.data("target-title"));
  }

  if (!param.hasOwnProperty('type')) param.type = 'GET';
  if (!param.hasOwnProperty('data')) param.data = null;
  if (!param.hasOwnProperty('element')) param.element = null;

  $.ajax({
    url: param.url,
    type: param.type,
    dataType: 'json', //expect json as return
    data: param.data,
    beforeSend: function(jqXHR, settings) {
      msg = Messenger().post({
        message: 'Processing...',
        type: 'info',
        hideAfter: 20,
        showCloseButton: true,
        hideOnNavigate: true,
        singleton: true,
      });
    },
    error: function(e) {
      const message = `<div class="">${_.get(e, 'responseJSON.exception', 'Error')}.
        ${_.get(e, 'responseJSON.message')}
      </div>`;

      $target.find('.modal-body').html(`${_.get(e, 'responseJSON.message', 'Error')}`);

      msg.update({
        message: message,
        type: 'error',
      });

      $target.modal('hide');

      setTimeout(function() {
        msg.hide();
      }, 5000);
    },
    success: function(result) {
      if (result.hasOwnProperty('html')) {
        $target.find('.modal-body').html(result.html);

        setTimeout(function() {
          $target.find('form :input:enabled:visible:first').focus();
        }, 250);
      }

      if (result.success != null && !result.success) {
        msg.update({ message: result.message, type: 'error' });
      } else {
        if (result.message != null && result.message.length > 0) {
          msg.update({ message: result.message, type: 'success' });
        } else {
          msg.update({ message: 'Done!', type: 'success' });
        }

        $target.trigger('fetched.modal', result);
      }

      setTimeout(function() {
        msg.hide();
      }, 500);
    },
  });
};
